/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { PresenceBadge_DisplayFragmentDoc } from '../../../__generated__/PresenceBadge.graphql';
import { CoupledBadge_DisplayFragmentDoc } from '../../../__generated__/CoupledBadge.graphql';
export type StatusCell_DisplayFragment = { __typename: 'Display', id: string, presence?: { __typename: 'DisplayPresence', connected: boolean } | null, host?: { __typename: 'Host', coupledState?: string | null, timestamp?: any | null } | null };

export const StatusCell_DisplayFragmentDoc = gql`
    fragment StatusCell_display on Display {
  id
  ...PresenceBadge_display
  ...CoupledBadge_display
}
    ${PresenceBadge_DisplayFragmentDoc}
${CoupledBadge_DisplayFragmentDoc}`;